/**
 * Dashboard badge helpers.
 *
 * Task "pending" is every non-completed status (to-do, in progress,
 * awaiting feedback, testing). Subtracting ``completed`` from ``total``
 * stays correct if the backend adds a status later; a hard-coded sum of
 * today's four open statuses would silently under-count.
 *
 * Complaint "pending" is the named ``pending`` status — that is the
 * ticket queue the Complaints dashboard already labels "Pending".
 */

export function pendingTaskCount(summary) {
  if (!summary || typeof summary !== 'object') return 0;
  const total = Number(summary.total) || 0;
  const completed = Number(summary.by_status?.completed) || 0;
  return Math.max(0, total - completed);
}

export function pendingComplaintCount(summary) {
  if (!summary || typeof summary !== 'object') return 0;
  return Number(summary.by_status?.pending) || 0;
}

export function countNounLabel(count, singular, plural) {
  const n = Number(count) || 0;
  const noun = n === 1 ? singular : (plural || `${singular}s`);
  return `${n} ${noun}`;
}
